// One home for what every notification preference means when nothing is
// stored. Defaults reproduce the behaviour TeamX had before preferences
// existed, so a user who never opens the panel notices no change.
//
// If a default ever starts appearing at a call site instead of here, this
// module has stopped doing its job.

export const DEFAULTS = {
    'notifications.flashApp': 'true',
    'notifications.sound': 'true',
    'notifications.desktop': 'true',
    'notifications.announcements': 'true',
    'notifications.unreadTabFlash': 'true',
    // The one preference that does not default to "on". A toast fires only
    // when neither TeamX window has focus - which is exactly when someone
    // other than the reader may be looking at the screen - and it stays in the
    // Windows notification history afterwards. Showing the message itself is
    // a real change to who can see it, so it is opted into, never out of.
    'notifications.preview': 'false',
    'startup.openChatWindow': 'always',
};

export const prefKey = (category, name) => category + '.' + name;

export const getPref = (preferences, category, name) => {
    const key = prefKey(category, name);
    const stored = preferences ? preferences[key] : undefined;
    return stored === undefined || stored === null ? DEFAULTS[key] : stored;
};

// Anything that is not the string 'false' counts as on, so a corrupt or
// unrecognised value fails towards notifying rather than towards silence.
export const isOn = (preferences, category, name) =>
    getPref(preferences, category, name) !== 'false';

export default { DEFAULTS, prefKey, getPref, isOn };



// WEBPACK FOOTER //
// ./src/utils/notificationPreferences.js